// extracted by mini-css-extract-plugin
module.exports = {"input":"InputNumber_input__3adF6","hideNumberArrows":"InputNumber_hideNumberArrows__1oGqg","select":"InputNumber_select__8i3Ce"};